import { useNavigate } from '@solidjs/router'
import ChatLeftNavItem from './components/ChatLeftNavItem'
import GenerateButton from '/web/shared/aifans/model/buttons/GenerateButton'
import { userStore } from '/web/store'

const ChatLeftNav = (props: any) => {
  const nav = useNavigate()

  return (
    <div class="flex h-full flex-col justify-between">
      <div class="flex flex-col gap-5 p-4">
        <GenerateButton title="GENERATE IMAGE" onClick={() => nav('/generate-image/')} />
        <ChatLeftNavItem icon="/images/nav-home-icon.png" title="Home" href="/" />
        <ChatLeftNavItem icon="/images/nav-chat-icon.png" title="Chat" href="/chat/" />
        <ChatLeftNavItem icon="/images/nav-gallery-icon.png" title="Gallery" href="/gallery/" />
        <button
          class="flex items-center"
          onClick={() => {
            userStore.characterModal(true)
            userStore.closeSideMenu()
          }}
        >
          <img src={'/images/nav-character-requests-icon.png'} class="h-6 w-6" />
          <span class="ml-3 font-clash text-base text-white/80">Character Requests</span>
        </button>
      </div>
      <div class="flex flex-col gap-5 border-t border-t-cosplay-gray-100 px-4 py-6 ">
        <ChatLeftNavItem
          icon="/images/nav-money-icon.png"
          title="Affiliate"
          href="https://docs.google.com/forms/d/e/1FAIpQLSfB-bwkfjmt8aGBXV9mCk0QkfKHbK2t-jMvUI3n1ePGGuqN0A/viewform"
          target="_blank"
        />
        <ChatLeftNavItem icon="/images/nav-contact-icon.png" title="Contact" href="/contact-us/" />
      </div>
    </div>
  )
}
export default ChatLeftNav
